import React, { useRef, useEffect } from "react";
import config from "../data/config";
import { mediaData } from "../data/mediaData";
import ShareIconWrapper from "./ShareIconWrapper";

const SwiperVideoBlock = ({
  chapterInfo,
  isActive,
  isSlidePaused,
  pauseSlideOnTap,
  callGaHandler,
  shareRef,
}) => {
  const videoRef = useRef(null);

  useEffect(() => {
    videoRef.current.defaultMuted = true;
    if (isActive) {
      if (videoRef.current) {
        if (!isSlidePaused) {
          videoRef.current.play();
        } else {
          videoRef.current.pause();
        }
      }
    }
  }, [isActive, isSlidePaused]);

  const pauseSlide = () => {
    pauseSlideOnTap(true);
  }

  return (
    <div className="swiper-block">
      <ShareIconWrapper ref={shareRef} callGaHandler={callGaHandler} pauseSlideOnTap={pauseSlideOnTap} />

      <div className="video-wrapper">
        <video
          preload="true"
          muted
          playsInline
          disablePictureInPicture
          ref={videoRef}
          // poster={mediaData["videoPoster"]}
          controls={false}
          onClick={pauseSlide}
        >
          <source
            // src={mediaData[`${chapterInfo?.chapter_media_url}`]}
            src={`${config.BUCKET_URL}${chapterInfo?.chapter_media_url}`}
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
        {isActive && isSlidePaused ? (
          <span className="play-button">
            <img alt="play" src={mediaData['playButton']} onClick={pauseSlide} />
          </span>
        ) : null}
      </div>
      <div className="slide-footer d-none d-xl-block">
        <div className="footer-left">
          <div className="slide-main-title">{chapterInfo?.chapter_name}</div>
          <div className="slide-hashtags">
            {chapterInfo?.chapter_hash_tags &&
            chapterInfo?.chapter_hash_tags.length > 0 ? (
              chapterInfo?.chapter_hash_tags.map((item, index) => (
                <span key={index}>{item}</span>
              ))
            ) : (
              <span></span>
            )}
          </div>
        </div>
        {/* <div className="slide-footer-image">
                    <img src={`${mediaData["footSwipeDummy"]}`} alt="" />
                  </div> */}
      </div>
    </div>
  );
};

export default SwiperVideoBlock;
